import axios from "axios";

export const ipifyService = async() =>{
    let url = "https://api.ipify.org";
    return await axios.get(url);
}